export const SET_DOCUMENT_FORMATS = 'SET_DOCUMENT_FORMATS';
export const DELETE_DOCUMENT_FORMAT = 'DELETE_DOCUMENT_FORMAT';
